export const shouldUseFPXDirectDebit = (countryOfOperation: string) =>
  ["Malaysia"].includes(countryOfOperation);

export const shouldUseDuitnowPayDirectDebit = (ch: { name: string }[]) => {
  return ch.some((c) => c.name.includes("DUITNOW_PAY"));
};
